import styled from "styled-components";
import { LegendBox } from "../../molecules/Legends/Legends.style";

export const SystemSection = styled.section`
  display: flex;
  margin-bottom: 20px;
  padding: 28px;
  background: ${(props) => props.theme.colors.primary5};
  border-radius: 6px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 28px;

  ${LegendBox} {
    width: 1031px;
  }

  // 화면크기(1400px 미만) 설정
  @media (max-width: 1399px) {
    ${LegendBox} {
      width: 100%;
    }
  }
`;

export const SystemContent = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 20px;

  // 화면크기(1400px 미만) 설정
  @media (max-width: 1399px) {
    flex-direction: column;
  }
`;

export const SystemContentComment = styled.div`
  display: none;
  width: 100%;
  color: ${(props) => props.theme.colors.primary38};
  font-size: 1.4rem;
  font-weight: 600;
  text-align: end;

  // 화면크기(980px 미만) 설정
  @media (max-width: 979px) {
    display: block;
  }
`;
